// src/utils/cnpjValidator.js
export const CnpjValidator = {
    isValid(cnpj) {
        if (!cnpj) return false;
        
        const cnpjDigits = cnpj.replace(/\D/g, '');
        
        if (cnpjDigits.length !== 14) return false;
        
        if (new Set(cnpjDigits).size === 1) return false;
        
        return this.validateDigits(cnpjDigits);
    },
    
    validateDigits(cnpj) {
        // Validação do CNPJ (já temos)
        const firstMultipliers = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
        let sum = 0;
        
        for (let i = 0; i < 12; i++) {
            sum += parseInt(cnpj[i]) * firstMultipliers[i];
        }
        
        let remainder = sum % 11;
        let firstDigit = remainder < 2 ? 0 : 11 - remainder;
        
        if (parseInt(cnpj[12]) !== firstDigit) return false;
        
        const secondMultipliers = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
        sum = 0;
        
        for (let i = 0; i < 13; i++) {
            sum += parseInt(cnpj[i]) * secondMultipliers[i];
        }
        
        remainder = sum % 11;
        let secondDigit = remainder < 2 ? 0 : 11 - remainder;
        
        return parseInt(cnpj[13]) === secondDigit;
    },

    // Método para formatar CNPJ
    format(cnpj) {
        const digits = cnpj.replace(/\D/g, '');
        if (digits.length <= 2) return digits;
        if (digits.length <= 5) return `${digits.slice(0, 2)}.${digits.slice(2)}`;
        if (digits.length <= 8) return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5)}`;
        if (digits.length <= 12) return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}/${digits.slice(8)}`;
        return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}/${digits.slice(8, 12)}-${digits.slice(12)}`;
    },

    // Método para limpar formatação
    clean(cnpj) {
        return cnpj.replace(/\D/g, '');
    },

    // 🔥 NOVO: Gera um CNPJ válido
    generateValidCnpj() {
        // Passo 1: Gerar os primeiros 8 dígitos (raiz)
        // Os 8 primeiros dígitos devem ser números aleatórios
        let cnpj = '';
        for (let i = 0; i < 8; i++) {
            cnpj += Math.floor(Math.random() * 9) + 1; // 1-9 (não pode começar com 0)
        }
        
        // Passo 2: Gerar os 4 dígitos da filial
        for (let i = 0; i < 4; i++) {
            cnpj += Math.floor(Math.random() * 10); // 0-9
        }
        
        // Agora temos 12 dígitos: XX.XXX.XXX/XXXX
        // Faltam os 2 dígitos verificadores
        
        // Passo 3: Calcular o primeiro dígito verificador
        const firstMultipliers = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
        let sum = 0;
        for (let i = 0; i < 12; i++) {
            sum += parseInt(cnpj[i]) * firstMultipliers[i];
        }
        let remainder = sum % 11;
        let firstDigit = remainder < 2 ? 0 : 11 - remainder;
        cnpj += firstDigit; // Adiciona o primeiro dígito
        
        // Passo 4: Calcular o segundo dígito verificador
        const secondMultipliers = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
        sum = 0;
        for (let i = 0; i < 13; i++) {
            sum += parseInt(cnpj[i]) * secondMultipliers[i];
        }
        remainder = sum % 11;
        let secondDigit = remainder < 2 ? 0 : 11 - remainder;
        cnpj += secondDigit; // Adiciona o segundo dígito
        
        // Agora temos um CNPJ com 14 dígitos VÁLIDO!
        return cnpj; // Retorna apenas números: "12345678000199"
    }
};